import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";
import { storage } from "../firebase";

import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
  Row,
} from "react-bootstrap";
import firebase from "../firebase";


const AddPost = () =>{
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState("");
  const [progress, setProgress] = useState(0);
  const [addPostID,setaddPostID] = useState('');
  const [addDescription,setaddDescription] = useState('');

  const handleAddImage = e =>{
    if(e.target.files[0]){
        setImage(e.target.files[0]);
    }
  }

const handleUpload = () =>{
  const uploadTask = storage.ref(`images/${image.name}`).put(image);
  uploadTask.on(
    "state_changed",
    snapshot => {
      const progress = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      setProgress(progress);
    },
    error => {
        console.log(error);
    },
    () => {
      storage
        .ref("images")
        .child(image.name)
        .getDownloadURL()
        .then(url =>{
          //console.log(url);
          setUrl(url);
        });
    }
  );
};

const handleAddPost = () =>{
  handleUpload()
  if(addPostID && addDescription){
  const firestore = firebase.database().ref("/PostInfo")
  let data = {
    PostID:addPostID,
    Description:addDescription,
    imageURL:url
  }
  firestore.push(data);
  alert("Succfully Added");
  setaddPostID("");
  setaddDescription("");
  }

  else {
    alert("Please Fill all the Fields")
  } 
};

    return (
        <>

<AdminS/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  
        <Container fluid>
        <Row>
          <Col md="11">
            <Card>
              <Card.Header>
                <Card.Title as="h4"></Card.Title>
            <progress value={progress} max = "100"/>

              </Card.Header>
              <Card.Body>
                <Form>
                <Row>
                    <Form.Label column sm={4}>
                    Post ID
                    </Form.Label>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <Form.Control
                          defaultValue=""
                          placeholder="Post ID"
                          type="text"
                          focus value = {addPostID} onChange={(e)=>{setaddPostID(e.target.value);}}
                          required
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    </Row>

                    <Row>
                    <Form.Label column sm={4}>
                    Description
                    </Form.Label>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <Form.Control
                          defaultValue=""
                          placeholder="Description about Your Advertisment"
                          rows="4"
                          as="textarea"
                          focus value = {addDescription} onChange={(e)=>{setaddDescription(e.target.value);}}
                          required
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    </Row>

                    <input type ="file" onChange={handleAddImage}/>
                    <button onClick={()=>{handleAddPost()}} type="button" class="btn btn-primary btn-lg btn-block">Add</button>
                    
                    {url}
                    <img src ={url || "http://via.placeholder.com/300"} alt = "firebase-image" />
                    </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>        

      </Col>
  </Row>
</Container>
<Footer /> 
        </>
    );
}
export default AddPost;
